module.exports = __webpack_public_path__ + "static/media/krani.16589c06.svg";